import { DsbcApiOptions } from '../_dsapi/DsbcApiOptions';
import { createDsbcApiUrl } from '../createDsbcApiUrl';
import { DsbcApi } from '../createDsbcRequest';
import { BaseRequest, BaseResponse } from '../shared';

interface getBulletRwdListRequest extends BaseRequest {
  invId: string; //邀请活动ID ,
}

interface getBulletRwdListResponse extends BaseResponse {
  Data: string[];
}

/**
 * 轮播数据
 * @param params
 * @returns
 */
export async function getBulletRwdList(request: getBulletRwdListRequest, options?: DsbcApiOptions) {
  const url = await createDsbcApiUrl('/inv/getBulletRwdList');
  return DsbcApi.fetch<getBulletRwdListResponse>(url, request, false, options);
}
